'use client';

import { useRef, useEffect, useState } from 'react';

import { useMediaQuery, useOffsetTop } from '@monoimin/hooks';

import { HeaderContent } from './HeaderContent';

import type { LinkStoryblok } from '@monoimin/sb-types';

type StickyHeaderProps = {
  links: Array<LinkStoryblok>;
  className?: string;
};

export const StickyHeader = ({ links, className }: StickyHeaderProps) => {
  const { ref, isReached: fixedHeader } = useOffsetTop({ gap: 68 });

  const scrollContainerRef = useRef<HTMLDivElement>(null);

  const previousScrollRef = useRef<number | undefined>(undefined);

  const [scrollDirection, setScrollDirection] = useState<
    'top' | 'bottom' | null
  >(null);

  const isDesktop = useMediaQuery(`(min-width: 768px)`);

  const hideHeader = !isDesktop && scrollDirection === 'bottom' && fixedHeader;

  useEffect(() => {
    const controlDirection = () => {
      if (previousScrollRef.current) {
        if (window.scrollY > previousScrollRef.current) {
          setScrollDirection('bottom');
        } else {
          setScrollDirection('top');
        }
      }

      previousScrollRef.current = window.scrollY;
    };

    window.addEventListener('scroll', controlDirection);

    return () => {
      window.removeEventListener('scroll', controlDirection);
    };
  }, []);

  return (
    <div ref={ref}>
      <HeaderContent
        links={links}
        className={className}
        fixedHeader={fixedHeader}
        hideHeader={hideHeader}
        scrollContainerRef={scrollContainerRef}
      />
    </div>
  );
};
